import template from './objectives.template.html';

export default {
  template,
  bindings: {
    objectives: '<',
    contacts: '<',
    workflow: '<'
  },
controller: class controller {
    constructor($rootScope, $mdUtil, helperService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableInterestOnlyReason = [];
      ctrl.availableRatings = [];
      ctrl.simpleSelectOptions = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availableInterestOnlyReason = helperService.getAvailableInterestOnlyReason();
        ctrl.availableRatings = helperService.getAvailableRatings();
        ctrl.simpleSelectOptions = helperService.getSimpleSelectOptions();
        ctrl.objectives = ctrl.objectives || null;
        ctrl.contacts = ctrl.contacts || [];
        ctrl.workflow = ctrl.workflow || null;
        ctrl.isReady = true;
      };

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.contacts.length) {
          contact = ctrl.contacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
